/* Catalog data and note-type helpers
 *
 * Moved verbatim from currencykeep_2026-08-03.html, lines 360-367.
 * The body below was byte-identical to the original, with only the import
 * block above and the export block below added (Phase 1, Step 2) — until
 * 2026-09-15, Phase 6.5 step 3.3: GLABEL gained `custom`, and CUSTOM_GRADE
 * names that key so no other file spells it. Jesse's ruling 3, 2026-09-13:
 * "a 'custom' grade tab on every note".
 */

// The 11,614-row Friedberg catalog. Extracted out of the HTML file so a
// code change no longer invalidates 2.5 MB of catalog in the browser
// cache. Top-level await keeps every consumer below synchronous, exactly
// as it was when the array was inlined.
// PHASE 7: this file MUST be precached by the service worker or offline
// browsing breaks — see BUILD_NOTES.md.
// (import.meta.env is Vite's; the ?? keeps this module loadable under
// plain Node for the smoke test, which has no Vite around it.)
const BASE = import.meta.env?.BASE_URL ?? '/'
const res = await fetch(`${BASE}catalog.json`)
if (!res.ok) throw new Error(`catalog.json failed to load (${res.status})`)
export const CATALOG = await res.json()

CATALOG.forEach((n,i)=>n.id=i);
const BY_SID={};CATALOG.forEach(n=>{BY_SID[n.sid]=n;});
const SID_ALIAS={"SC:229b":"SC:229a★","SC:274m":"SC:274★","GC:1166ii":"GC:1166II","GC:1166iii":"GC:1166III","GC:1166iV":"GC:1166IV","SSC:1613L":"SSC:1613W","SSC:1613L★":"SSC:1613W★","SFR:1919-C":"SFR:1919-G","SFR:1919-C★":"SFR:1919-G★","SFR:1917-G":"SFR:1917-F:fu","SFR:3003-E":"SFR:3003-F","SFR:1936-B":"SFR:1936-B★","SFR:1936-D":"SFR:1936-D★","SFR:1937-A":"SFR:1937-A★","SFR:1939-J":"SFR:1939-K","SFR:1966-C":"SFR:1966-G","SFR:1966-C★":"SFR:1966-G★","SFR:1983-C":"SFR:1983-G","SFR:1989-E":"SFR:1989-F","SFR:2036-L":"SFR:2036-L★"};
const GRADES=["VG8","F12","VF20","EF40","CU60","Ch63","Gem65"];
const GLABEL={VG8:"VG-8",VG10:"VG-10",F12:"F-12",F15:"F-15",VF20:"VF-20",VF25:"VF-25",VF30:"VF-30",EF40:"EF-40",EF45:"EF-45",AU50:"AU-50",AU55:"AU-55",AU58:"AU-58",CU60:"CU-60",CU62:"CU-62",CU64:"CU-64",CU66:"CU-66",Ch63:"Ch CU-63",Ch64:"Ch CU-64",Ch66:"Ch CU-66",Gem65:"Gem-65",custom:"Custom"};
// The one grade key that is never in a note's price columns: a holder grade
// the tabs do not carry. It has a label and no price, on every note.
const CUSTOM_GRADE="custom";
/* The custom grade's NUMBER rides in the key — "custom:66". His ruling
 * 2026-09-17, from the walk: "the Custom chip expands into a number field
 * when tapped, and the collector types their exact grade — 25, 35, 66"; no
 * new columns, and `grade` is free text end to end. A bare "custom" is the
 * chip tapped and nothing typed yet. ⚠ `grade` is PUBLIC (public_holdings
 * projects it), so the number reaches a stranger's card exactly as VF-20
 * does. The number prices nothing: bookVal indexes the note's own price
 * columns and this key is never in them. */
function isCustomGrade(g){return g===CUSTOM_GRADE||(typeof g==="string"&&g.startsWith(CUSTOM_GRADE+":"));}
function customGradeNumber(g){if(!isCustomGrade(g)||g===CUSTOM_GRADE)return null;const n=+g.slice(CUSTOM_GRADE.length+1);return Number.isInteger(n)&&n>=1&&n<=70?n:null;}
function customGradeKey(n){return Number.isInteger(n)&&n>=1&&n<=70?CUSTOM_GRADE+":"+n:CUSTOM_GRADE;}
/* Every site that prints a HOLDING's grade goes through this: the label,
 * or "Custom 66", or the raw key so nothing ever prints `undefined`. */
function gradeLabel(g){if(GLABEL[g])return GLABEL[g];if(isCustomGrade(g)){const n=customGradeNumber(g);return n==null?GLABEL[CUSTOM_GRADE]:GLABEL[CUSTOM_GRADE]+" "+n;}return g||"—";}
function gradesOf(n){return (n&&n.gl)?n.gl:GRADES;}
function isCol(n){return !!(n&&n.section==="Colonial");}function isObs(n){return !!(n&&n.section==="Obsolete Note");}function obsState(n){return isObs(n)?(n.desc||"").split(" · ")[0]:"";}function refOf(h,n){return (h&&h.ref)?h.ref:((n&&n.fr)||"");}
function colState(n){return isCol(n)?(n.desc||"").split(" · ")[0]:"";}

export {
  BY_SID,
  CUSTOM_GRADE,
  GLABEL,
  GRADES,
  SID_ALIAS,
  colState,
  customGradeKey,
  customGradeNumber,
  gradeLabel,
  gradesOf,
  isCustomGrade,
  isCol,
  isObs,
  obsState,
  refOf,
}
